import React, {useEffect, useMemo} from 'react';
import CatalogLink, {StyledCatalogLink} from "./CatalogLink";
import BigLogoSVG from "../../icons/BigLogoSVG";
import styled from "styled-components";
import {useMediaQuery} from "usehooks-ts";
import * as _ from "lodash";

const StyledAdvantages = styled.section`
    padding: 104px 0;
    color: #fff;
    background: #5b77cb;
    position: relative;
    min-height: 750px;
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;

    @media screen and (max-width: 1919px) {
        padding: 67px 0;
        min-height: 0;
    }

    .adv-left-part {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        gap: 20px;
    }

    .container {
        display: flex;
        flex: 1 1 auto;
        z-index: 1;


        h2 {
            margin-right: 160px;
            white-space: nowrap;
        }

        @media screen and (max-width: 1919px) {
            margin: 0 20px;
            h2 {
                margin-right: 90px;
            }
        }
    }

    > svg {
        position: absolute;
        bottom: -150px;
        z-index: 0;
        pointer-events: none;
    }

    .advantages-grid-wrap {
        display: flex;

        .advantages-grid {
            display: flex;
            flex-direction: column;
            gap: 108px;
            border-left: 1px solid #FFFFFF;

            &:not(:last-child) {
                margin-right: 20px;
            }

            &:last-child:not(:first-child) {
                .advantage:first-child {
                    margin-top: auto;
                }
            }
        }

        @media screen and (max-width: 1919px) {
            flex-direction: column;
            .advantages-grid {
                gap: 40px;

                &:not(:first-child) {
                    padding-top: 40px;
                }
            }
        }
    }

    .advantage {
        padding-left: 22px;
        position: relative;
        min-width: 310px;

        &::after {
            content: "";
            position: absolute;
            left: -7px;
            top: 8px;
            width: 13px;
            height: 13px;
            border-radius: 50%;
            background: #FFFFFF;
        }
    }

    .advantage h3 {
        margin: 0 0 14px;
        font-size: 20px;
        font-weight: 600;
    }

    .advantage p {
        opacity: .78;
        font-size: 18px;
        line-height: 1.4;
    }

    @media (max-width: 999px) {
        padding: 64px 0;

        .container {
            flex-direction: column;

            ${StyledCatalogLink} {
                margin-top: 48px;
            }

            .adv-left-part {
                margin-bottom: 38px;
            }

            .advantages-grid {
                border: 0;

                &:not(:first-child) {
                    padding-top: 32px;
                }
            }
        }
    }
`;

type AdvantagesProps = {
    items: {
        title: string,
        text: string,
    }[]
}

function Advantages({items}: AdvantagesProps) {
    const mobileSize = useMediaQuery('(max-width: 999px)')

    if (items.length > 4) {
        throw new Error("Advantages supports maximum 4 items")
    }

    const itemsToRender = useMemo(() => {
        return <div className="advantages-grid-wrap">
            {_.chunk(items, 2).map((advantages, index) => (
                <div className="advantages-grid" key={index}>
                    {advantages.map((advantage, advantageIndex) => (
                        <article className="advantage" key={`${index}_${advantageIndex}`}>
                            <h3>{advantage.title}</h3>
                            <p>{advantage.text}</p>
                        </article>))}
                </div>
            ))
            }
        </div>
    }, [items]);

    return (
        <StyledAdvantages>
            <div className="container">
                <div className="adv-left-part">
                    <h2>Наши преимущества</h2>
                    {!mobileSize && <CatalogLink/>}
                </div>
                {itemsToRender}
                {mobileSize && <CatalogLink/>}
            </div>
            <BigLogoSVG/>
        </StyledAdvantages>
    );
}

export default Advantages;